import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Questions from "../views/Questions";
import Branding from "../views/Branding";
import FunctionalSurvey from "../views/FunctionalSurvey";
import FunctionalSurveyResults from "../views/FunctionalSurveyResults";
import QuestionResponses from "../views/QuestionResponses";
import Profile from "../views/profile/Profile";
import Dashboard from "../views/dashboard/Dashboard";
import { loginSession, LoginSessionProvider } from "shared/LoginSession";
import { InternalReferrerProvider } from "shared/hooks/useInternalReferrer";
import NotFound from "shared/pages/NotFound";
import sharedConfig from "shared/config";
import { AppAccessChecker } from "shared/AppAccessChecker";
import FHCHud from "components/FHCHud";

import { SuperuserRouteWrapper } from "shared/components/SuperuserComponent";
import AdminConfiguration from "views/admin/AdminConfiguration";
import AdminLayout from "layouts/AdminLayout";

import apps from "shared/apps";
import { getRelativePath } from "shared/utils";

import "../css/tailwind.css";
import "../css/index.scss";

const WebRoute = () => {
    const inIframe = window.self !== window.top;

    return (
        <InternalReferrerProvider>
            <LoginSessionProvider>
                <Routes>
                    {/** If not in iframe: require app access */}
                    {!inIframe && (
                        <Route element={<AppAccessChecker appAccessPermission={"FHC_ACCESS"} />}>
                            <Route element={<FHCHud />}>
                                <Route element={<AdminLayout />}>
                                    <Route path="/admin" element={<SuperuserRouteWrapper />}>
                                        <Route path="configuration" element={<AdminConfiguration />} />
                                    </Route>
                                </Route>
                                <Route path="/profile" element={<Profile />} />
                                {/*
                todo: DISABLED : until we have something functional
               <Route
                path="/dashboard"
                element={
                  <Dashboard />
                }
              /> */}
                                <Route path="/questions" element={<Questions />} />
                                <Route path="/responses" element={<QuestionResponses />} />
                                <Route path="/branding" element={<Branding />} />

                                {/** Navigate seamlessly(replace=true) to landing page from / */}
                                <Route
                                    path="/"
                                    element={
                                        <Navigate to={getRelativePath(apps.FHC_ACCESS.getAppLandingPage())} replace />
                                    }
                                />

                                {/** Redirect to homepage if not in iframe and not logged in */}
                                <Route
                                    path="*"
                                    element={
                                        <NotFound
                                            homeRoute={
                                                loginSession.userInfo
                                                    ? {
                                                          superuserHomeRoute: `${sharedConfig.centralFrontendURL}superuser`,
                                                          userHomeRoute: "/questions",
                                                      }
                                                    : sharedConfig.centralFrontendURL
                                            }
                                        />
                                    }
                                />
                            </Route>
                        </Route>
                    )}
                    <Route path="/survey/:surveyLinkKey" element={<FunctionalSurvey isIframe={inIframe} />} />
                    <Route
                        path="/survey/results/:surveyLinkKey"
                        element={<FunctionalSurveyResults isIframe={inIframe} />}
                    />
                </Routes>
            </LoginSessionProvider>
        </InternalReferrerProvider>
    );
};

export default WebRoute;
